import React from 'react'
import "./Adv_banner.css"

const Adv_banner = () => {
  return (
    <>      
        <section className="adv_banner_section">
            <div className="container-fluid p-0">
                <div className="adv_banner_div">
                    <img className='bannerimg' src={process.env.PUBLIC_URL + '/assets/images/advantage/banner/banner.png'} />
                </div>
            </div>
        </section>
    </>
  )
}

export default Adv_banner